import React, { useState, useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { SidebarComponent, CameraGrid, Header } from "./Sidebar";
import { v4 as uuidv4 } from 'uuid';

// Constants for colors
const COLORS = {
  DARK_GRAY: "#2A2E34",
};

const App = () => {
  // const [currentTime, setCurrentTime] = useState("");
  // const [mobileOpen, setMobileOpen] = useState(false);
  // const [gridItems, setGridItems] = useState([]);
  // const [allCameras, setAllCameras] = useState([]);
  // const [selectedLocs, setSelectedLocs] = useState([]);
  // const [getdc, setGetdc] = useState([]);
  // const [selectedCity, setSelectedCity] = useState("");
  // const [locdetails, setLocdetails] = useState([]);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  // const [displays, setDisplays] = useState(6);
  // const pollingRef = useRef(null);
  // const locsRef = useRef([]);
  // const prevLocsRef = useRef([]);
  // const connectionIdRef = useRef(uuidv4());
  // const isHandlingError = useRef(false);

  // useEffect(() => {
  //   const updateTime = () => {
  //     const now = new Date();
  //     const day = String(now.getDate()).padStart(2, "0");
  //     const month = String(now.getMonth() + 1).padStart(2, "0");
  //     const year = now.getFullYear();
  //     const hours = String(now.getHours()).padStart(2, "0");
  //     const minutes = String(now.getMinutes()).padStart(2, "0");
  //     const seconds = String(now.getSeconds()).padStart(2, "0");
  //     const dayName = now.toLocaleString("en-US", { weekday: "short" });
  //     setCurrentTime(
  //       `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${dayName}`
  //     );
  //   };

  //   updateTime();
  //   const interval = setInterval(updateTime, 1000);
  //   return () => clearInterval(interval);
  // }, []);

  // const handleDrawerToggle = () => {
  //   setMobileOpen(!mobileOpen);
  // };
  // const handleToggleSidebar = () => {
  //   setIsSidebarOpen((prev) => !prev);
  // };

  // const handleGetDc = async () => {
  //   try {
  //     const response = await axios.post(
  //       "https://api.more.in/v1/vigil_portal",
  //       {
  //         rawPath: "/get_dc",
  //       },
  //       {
  //         headers: {
  //           Authorization: Cookies.get("ssp_sso_token"),
  //           "content-type": "application/json",
  //         },
  //       }
  //     );
  //     if (response?.data?.status === "success") {
  //       setGetdc(response?.data?.message?.records);
  //     } else {
  //       toast.error(
  //         response?.data?.message ||
  //         "Something went wrong, Please try again later!",
  //         { position: "top-right" }
  //       );
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const handleGetLogs = async () => {
  //   try {
  //     const response = await axios.post(
  //       "https://api.more.in/v1/vigil_portal",
  //       { dc_city: selectedCity, rawPath: "/get_locs" },
  //       {
  //         headers: {
  //           Authorization: Cookies.get("ssp_sso_token"),
  //           "content-type": "application/json",
  //         },
  //       }
  //     );
  //     if (response?.data?.status === "success") {
  //       setAllCameras(response?.data?.message?.records);
  //     } else {
  //       toast.error(
  //         response?.data?.message ||
  //         "Something went wrong, Please try again later!",
  //         { position: "top-right" }
  //       );
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // useEffect(() => {
  //   handleGetDc();
  // }, []);
  // useEffect(() => {
  //   if (getdc.length > 0) {
  //     handleGetLogs();
  //   }
  // }, [selectedCity]);

  // const handleLivePolling = async (locs) => {
  //   try {
  //     const response = await axios.post(
  //       "https://api.more.in/v1/vigil_portal",
  //       { loc: locs, rawPath: "/live_connection_polling", connection_id: connectionIdRef.current },
  //       {
  //         headers: {
  //           Authorization: Cookies.get("ssp_sso_token"),
  //           "content-type": "application/json",
  //         },
  //       }
  //     );
  //     console.log(response);
  //   } catch (err) {
  //     console.log(err);
  //     toast.error("Something went wrong, please try again later!", {
  //       position: "top-right",
  //     });
  //   }
  // }

  // const handleGetData = async (prevLocs) => {
  //   const currentLocs = selectedLocs;
  //   const numericLocs = selectedLocs.map(Number);
  //   try {
  //     const response = await axios.post(
  //       "https://api.more.in/v1/vigil_portal",
  //       { locs: currentLocs, rawPath: "/streams_by_loc" },
  //       {
  //         headers: {
  //           Authorization: Cookies.get("ssp_sso_token"),
  //           "content-type": "application/json",
  //         },
  //       }
  //     );
  //     if (response?.data?.status == "success") {
  //       setLocdetails(response?.data?.message?.records);
  //       setDisplays(response?.data?.message?.display_cameras);
  //       handleLivePolling(numericLocs);
  //       if (pollingRef.current) {
  //         clearInterval(pollingRef.current);
  //       }
  //       pollingRef.current = setInterval(() => {
  //         handleLivePolling(locsRef.current);
  //       }, 10000);
  //     } else {
  //       toast.error(response?.data?.body?.message || "Something went wrong, please try again later!", {
  //         position: "top-right",
  //       });
  //       isHandlingError.current = true;
  //       setSelectedLocs(prevLocs);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     isHandlingError.current = true;
  //     setSelectedLocs(prevLocs);
  //     toast.error("Something went wrong, please try again later!", {
  //       position: "top-right",
  //     });
  //   }
  // };

  //   useEffect(() => {
  //     return () => {
  //       if (pollingRef.current) {
  //         clearInterval(pollingRef.current);
  //       }
  //     };
  //   }, []);

  //   useEffect(() => {
  //   if (isHandlingError.current) {
  //     isHandlingError.current = false;
  //     prevLocsRef.current = selectedLocs;
  //     return;
  //   }

  //   if (selectedLocs.length > 0) {
  //     handleGetData(prevLocsRef.current);
  //   }

  //   prevLocsRef.current = selectedLocs;
  // }, [selectedLocs]);
  //   useEffect(() => {
  //     locsRef.current = selectedLocs.map(Number);
  //   }, [selectedLocs]);

  //   const handleGridItemsChange = (value) => {
  //     const newGridItems = Array.from({ length: value }, (_, i) => ({
  //       id: i + 1,
  //     }));
  //     setGridItems(newGridItems);
  //   };

  //   const handleRemoveGridItem = (id) => {
  //     const newGridItems = gridItems.filter((item) => item.id !== id);
  //     setGridItems(newGridItems);
  //   };
  //   const handleCameraSelect = (camera) => {
  //     setGridItems((prevItems) => {
  //       if (
  //         prevItems.length >= Number(displays) ||
  //         prevItems.some((item) => item.id === camera.id)
  //       ) {
  //         return prevItems;
  //       }
  //       return [...prevItems, camera];
  //     });
  //   };

  //   useEffect(() => {
  //     setGridItems(prev =>
  //       prev.filter(
  //         item =>
  //           item.location !== undefined &&
  //           selectedLocs.includes(String(item.location))
  //       )
  //     );
  //   }, [selectedLocs]);
  //   console.log(selectedLocs, "selectedLocs");
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: COLORS.DARK_GRAY,
        color: "white",
        textAlign: "center",
        gap: 2,
      }}
    >
      <Typography variant="h1" sx={{ fontSize: "8rem", fontWeight: 700, lineHeight: 1, color: COLORS.PRIMARY ?? "#1976d2" }}>
        404
      </Typography>
      <Typography variant="h5" sx={{ fontWeight: 500, letterSpacing: 2, textTransform: "uppercase" }}>
        Page Not Found
      </Typography>
      <Typography variant="body1" sx={{ color: "gray", maxWidth: 400 }}>
        The page you're looking for doesn't exist
      </Typography>
    </Box>
  );
};

export default App;
